var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import { videoFragment } from "./videoFragment";
export { prepRoute as prepVideoRoute } from "./route";
export { prepView as prepVideoView } from "./View";
// export { fragment } from "./videoFragment";
export * from "./blocks";
var createFragmentDefinition = function (fragment, invocationName) { return ({
    definition: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), fragment),
    invocation: "...".concat(invocationName),
}); };
export var videoFragmentDefinition = createFragmentDefinition(videoFragment, "VideoFragment");
var templateObject_1;
